<template>
   <div class="tab">
        <span class="tab-exposure">
          <a href="#exposure">
              <span class="iconfont">&#xe7e7;</span>
              曝光台
          </a>
        </span>
        <!--
        <span>
            <a href="/hlwdc/ztzj/mindex.html">
                <span class="iconfont">&#xe7e9;</span>
                专题征集
            </a>
        </span>-->
        <span>
            <a href="#cat">
                <span class="iconfont">&#xe7e8;</span>
                督查回声
            </a>
        </span>
        <span>
           <span @click="handleToSx">
                <span class="iconfont">&#xe7e6;</span>
                 我要留言
           </span>
        </span>
   </div>
</template>

<script>
export default {
    name: '',
    data () {
            return {};
        },
        methods: {
            handleToSx(){
                console.log('点击了我要留言');
                this.$emit('handleToSx')
            }
        },
        components: {},
        mounted () {
        }
}
</script>

<style scoped lang="less">
    .noExposure {
        .tab-exposure {
            display: none!important;
        }
    }

   .tab {
       display: flex;
       background-color: @indexTabBg;
       .px2rem(height, 119);
       .px2rem(line-height, 119);
       .px2rem(margin-bottom, 30);
       .px2rem(border-radius, 20);
       .px2rem(font-size, 32);
       span{
          flex:1;

          font-weight: Bold;
          text-align: center;
          a{
            color:@grey700;
          }
          span {
            color:@grey700;
          }
          .iconfont{
              color:@iconfontRed;
              font-family: 'cmsicon'!important;
          }
       }
   }
</style>
